import { JsonObject, JsonProperty } from 'json2typescript';

import { PBCAddressInterface } from '../../../core';
import { StringAdapter } from '../../client/helpers/serializer/adapters/string.adapter';

@JsonObject('PBCAddress')
export class PBCAddress implements PBCAddressInterface {
    @JsonProperty('direccion', StringAdapter)
    private _street: string = undefined;

    @JsonProperty('ciudad', StringAdapter)
    private _city: string = undefined;

    @JsonProperty('pais', StringAdapter)
    private _country: string = undefined;

    @JsonProperty('comentario', StringAdapter, true)
    private _comment?: string = undefined;

    get street(): string {
        return this._street;
    }

    get city(): string {
        return this._city;
    }

    get country(): string {
        return this._country;
    }

    get comment(): string {
        return this._comment;
    }
}
